import { render, staticRenderFns } from "./SlaBadgeAzul.vue?vue&type=template&id=6ff4bec7&"
import script from "./SlaBadgeAzul.vue?vue&type=script&lang=js&"
export * from "./SlaBadgeAzul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports